import { InternalResourceId } from '../../../typings/internalBanners';

export const UPLOAD_INTERNAL_BANNER_IMAGE_BY_LINK = 'UPLOAD_INTERNAL_BANNER_IMAGE_BY_LINK';
export type UPLOAD_INTERNAL_BANNER_IMAGE_BY_LINK = typeof UPLOAD_INTERNAL_BANNER_IMAGE_BY_LINK;
export interface UploadInternalBannerImageByLink {
    type: UPLOAD_INTERNAL_BANNER_IMAGE_BY_LINK;
    link: string;
    bannerId: string;
    resourceId: InternalResourceId;
}
export function uploadInternalBannerImageByLinkAction(
    link: string,
    bannerId: string,
    resourceId: InternalResourceId
): UploadInternalBannerImageByLink {
    return {
        type: UPLOAD_INTERNAL_BANNER_IMAGE_BY_LINK,
        link,
        bannerId,
        resourceId
    };
}
